import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Receipt } from 'lucide-react';
import { portal } from '../api';
import StatusBadge from '../components/StatusBadge';

const TYPE_LABELS: Record<string, string> = {
  NEW_INSTANCE: 'Neubestellung',
  UPGRADE: 'Upgrade',
  DOWNGRADE: 'Downgrade',
  CANCELLATION: 'Kündigung',
  ADDON: 'Zusatzoption',
  MANUAL_ADJUSTMENT: 'Manuelle Anpassung',
};

export default function OrdersPage() {
  const { data: orders, isLoading } = useQuery({
    queryKey: ['portal', 'orders'],
    queryFn: portal.orders,
  });

  if (isLoading) {
    return (
      <div className="space-y-2 animate-pulse">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-16 bg-slate-100 rounded-lg" />
        ))}
      </div>
    );
  }

  if (!orders?.length) {
    return (
      <div className="bg-surface border border-slate-200 rounded-xl p-10 text-center">
        <Receipt className="mx-auto text-slate-300 mb-3" size={40} />
        <p className="text-slate-500">Noch keine Bestellungen vorhanden.</p>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Bestellungen</h1>
        <p className="text-sm text-slate-500">Ihre bisherigen Bestellungen und Änderungen.</p>
      </div>

      <div className="bg-surface border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left text-xs text-slate-500 uppercase tracking-wide">
              <th className="px-4 py-2.5 font-medium">Datum</th>
              <th className="px-4 py-2.5 font-medium">Produkt</th>
              <th className="px-4 py-2.5 font-medium">Art</th>
              <th className="px-4 py-2.5 font-medium">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {orders.map((order) => (
              <tr key={order.id}>
                <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
                  {new Date(order.createdAt).toLocaleDateString('de-DE')}
                </td>
                <td className="px-4 py-3 text-slate-900">
                  {order.plan?.product.name ?? '—'}
                  {order.plan && <span className="text-slate-400"> · {order.plan.name}</span>}
                </td>
                <td className="px-4 py-3 text-slate-600">
                  {TYPE_LABELS[order.type] ?? order.type}
                </td>
                <td className="px-4 py-3">
                  <StatusBadge status={order.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
